import React, { useCallback } from 'react';
import { getVisitPdf } from '../../services/api';
import { ReadonlyPdfView } from '../documents/ReadonlyPdfView';

interface ReadonlyChartViewProps {
  visitId: string;
}

export const ReadonlyChartView: React.FC<ReadonlyChartViewProps> = ({
  visitId,
}) => {
  const loadSource = useCallback(async () => {
    const response = await getVisitPdf({ path: { visit_id: visitId } });
    if (!response.data) return null;
    const url = URL.createObjectURL(
      new Blob([response.data as BlobPart], { type: 'application/pdf' })
    );
    return { src: url, cleanup: () => URL.revokeObjectURL(url) };
  }, [visitId]);

  return (
    <ReadonlyPdfView
      loadSource={loadSource}
      title='Chart Review'
      errorText='Failed to load chart review. Please try again.'
    />
  );
};
